const PROBE_TIMEOUT_MS = 5000;

/**
 * True when the server answers on /health. Any HTTP status counts, as only a request that never gets an answer
 * means the device cannot reach it. /health is never cached by the service worker.
 */
export async function probeServer(
	fetchFn: typeof fetch = fetch,
	timeoutMs = PROBE_TIMEOUT_MS
): Promise<boolean> {
	try {
		await fetchFn('/health', { cache: 'no-store', signal: AbortSignal.timeout(timeoutMs) });
		return true;
	} catch {
		return false;
	}
}
